import { err, ok, type Result } from "./result";

export type NullableText = string | null | undefined;

export const cleanNullableText = (value: NullableText): string | null => {
  const cleaned = value?.trim() ?? "";
  return cleaned === "" ? null : cleaned;
};

export const cleanOptionalText = (value: NullableText): string | undefined => {
  const cleaned = value?.trim() ?? "";
  return cleaned === "" ? undefined : cleaned;
};

export const cleanRequiredText = <Error>(
  value: string,
  error: Error,
): Result<string, Error> => {
  const cleaned = value.trim();
  return cleaned === "" ? err(error) : ok(cleaned);
};

export type PromptedRequiredText<Error> =
  | { readonly kind: "cancelled" }
  | { readonly kind: "ready"; readonly value: string }
  | { readonly kind: "invalid"; readonly error: Error };

export type PromptedOptionalText =
  | { readonly kind: "cancelled" }
  | { readonly kind: "ready"; readonly value: string };

export const promptedOptionalText = (value: string | null): PromptedOptionalText =>
  value === null ? { kind: "cancelled" } : { kind: "ready", value: value.trim() };

export const promptedRequiredText = <Error>(
  value: string | null,
  error: Error,
): PromptedRequiredText<Error> => {
  if (value === null) return { kind: "cancelled" };
  const cleaned = cleanRequiredText(value, error);
  return cleaned.ok
    ? { kind: "ready", value: cleaned.value }
    : { kind: "invalid", error: cleaned.error };
};

export const normalizeQueryText = (value: string): string =>
  value.replace(/\s+/g, " ").trim().toLowerCase();

export const formatCountLabel = (
  count: number,
  singular: string,
  plural = singular + "s",
): string =>
  `${count} ${count === 1 ? singular : plural}`;
